import axios from "axios";
import Constants from "../../../components.constants.js";


function createTagsMapper(tagsList) {
    let tempTagInfo = {}
    for (let tag of tagsList) {
        tempTagInfo[tag._id] = { _id: tag._id, name: tag.name }
    }
    return tempTagInfo
}


export default {

    async updateAllTagstoInMem(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.tagsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                context.commit("setTagsinfo", Object.assign(context.state.tags, createTagsMapper(resp.data.tags)))
                if ((resp.data.page + 1) <= resp.data.page_count) {
                    context.dispatch("updateAllTagstoInMem", { params: { page: resp.data.page + 1 } })
                }
                return {};
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateAllTagstoInMem][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },


    async getAllTagsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.tagsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllTagsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getTagsOnAutocomplete(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.tagsAutocompleteUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getTagsOnAutocomplete][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async addNewTag(context, payload = {}) {
        //payload : FUSION Users JSON schema

        try {
            let resp = await axios.post(Constants.tagsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[addNewTag][Store][Tag add resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[addNewTag][Store][Error occured while adding tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async updateExistingTag(context, payload = {}) {
        //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}
        try {
            let resp = await axios.put(`${Constants.tagsUrl}/${payload.params._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateExistingTag][Store][Tag update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateExistingTag][Store][Error occured while updating Tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async deleteExistingTag(context, payload = {}) {
        //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

        try {
            let resp = await axios.delete(`${Constants.tagsUrl}/${payload._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[deleteExistingTag][Store][Tag Delete resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[deleteExistingTag][Store][Error occured while deleting Tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async isTagAttachedToAnyAsset(context, payload = {}) {
        //payload : {_id:"3422344231"}

        try {
            let tagId = payload._id
            delete payload._id
            let resp = await axios.get(`${Constants.tagconfirmationUrl}/${tagId}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[isTagAttachedToAnyAsset][Store][Error occured while getting Tag attached confirmation info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getTagInfoFromServer(context, payload = {}) {
        //payload : {params:{tagId:"3422344231"}}

        try {
            let tagId = payload.params.tagId
            delete payload.params.tagId
            let resp = await axios.get(`${Constants.tagsUrl}/${tagId}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                if (!(tagId in context.state.tags)) {
                    context.commit("setTagsinfo", resp.data.tag)
                }
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getTagInfoFromServer][Store][Error occured while getting Tag info --->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
};